import React from "react";
import PageHero from "../components/PageHero";
import TrustIntro from "../components/TrustIntro";
import Stats from "../components/Stats";
import WhyProspera from "../components/WhyProspera";
import HowWeWork from "../components/HowWeWork";
import Testimonials from "../components/Testimonials";
import CTABanner from "../components/CTABanner";
import { IMAGES } from "../config/siteConfig";

export default function About() {
  return (
    <>
      <PageHero
        label="About Us"
        title="Building Digital"
        highlight="Presence."
        subtitle="Welcome to INRISOFT — digital experiences with maximum emotional impact. We develop, design and deliver websites, apps and creative campaigns that drive results."
        image={IMAGES.trust}
      />
      <TrustIntro />
      <Stats />
      <WhyProspera />
      <HowWeWork />
      <Testimonials />
      <CTABanner />
    </>
  );
}
